<template>
  <v-expansion-panels
    class="mb-4"
  >
    <v-expansion-panel>
      <v-expansion-panel-header> Tìm kiếm theo báo cáo nhân viên</v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-card
          class="ma-0 overflow-visible"
          outlined
        >
          <validation-observer v-slot="{ handleSubmit }">
            <v-list-item class="pa-0" three-line>
              <v-list-item-content class="overflow-visible pa-0">
                <v-row>
<!--                  <v-col cols="12" md="6">-->
<!--                    <v-autocomplete-->
<!--                      v-model="filterForm.departmentId"-->
<!--                      :items="departmentGroup"-->
<!--                      item-text="name"-->
<!--                      item-value="id"-->
<!--                      label="Tìm kiếm theo phòng ban"-->
<!--                      placeholder="Chọn team sale"-->
<!--                      color="primary"-->
<!--                      clearable-->
<!--                    />-->
<!--                  </v-col>-->
                  <v-col cols="12" md="6">
                    <v-select
                      v-model="filterForm.storeId"
                      :items="storeOptions"
                      item-text="text"
                      item-value="value"
                      label="Tìm kiếm theo kho"
                      placeholder="Chọn kho"
                      color="primary"
                      clearable
                    />
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-autocomplete
                      v-model="filterForm.shift"
                      :items="shiftListReport"
                      label="Tìm kiếm theo ca làm việc"
                      placeholder="Ca làm việc"
                      item-text="text"
                      item-value="value"
                      clearable
                    >
                    </v-autocomplete>
                  </v-col>
                  <v-col cols="12" md="6">
                    <validation-provider
                      name="Chọn ngày"
                      v-slot="{ errors }"
                      rules="required"
                    >
                      <common-range-picker
                        v-model="selectRange"
                        :clearable="true"
                        :aLight="'center'"
                        :defaultRange="defaultRange"
                        @change-date-range="changeDateRange"
                      />
                      <div class="v-text-field__details mt-1">
                        <div class="v-messages theme--light error--text" role="alert">
                          <div class="v-messages__wrapper">
                            <div class="v-messages__message">
                              {{ errors[0] }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </validation-provider>
                  </v-col>
                </v-row>
                <div class="text-center mb-4">
                  <v-btn
                    class="primary mx-0"
                    @click.prevent="handleSubmit(searchReport);"
                  >
                    <v-icon>mdi-magnify</v-icon>Tìm kiếm
                  </v-btn>
                </div>
              </v-list-item-content>
            </v-list-item>
          </validation-observer>
        </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>
<script>
  import TokenService from '../../../../../helpers/token';
  import * as moment from 'moment'
  import { shiftListReport, storeOptions } from '../../../../../helpers/constants'
  import RepositoryFactory from '../../../../../repositories/RepositoryFactory'

  const DepartmentRepository = RepositoryFactory.get('department')
  export default {
    components: {
    },
    props: {
      filterForm: {
        default: () => ({}),
      },
    },
    data () {
      return {
        shiftListReport,
        storeOptions,
        departments: [],
        defaultRange: {
          startDate: moment().format('YYYY-MM-DD'),
          endDate: moment().format('YYYY-MM-DD'),
        },
        selectRange: [{
          startDate: moment().format('YYYY-MM-DD 00:00:00'),
          endDate: moment().format('YYYY-MM-DD 23:59:59'),
        }],
        departmentGroup: [],
      }
    },
    created () {
      this.getDepartmentList()
    },
    methods: {
      searchReport () {
        Bus.$emit('a-department-report-list-filter', this.filterForm)
      },

      async getDepartmentList () {
        const response = await DepartmentRepository.list({limit: 100, type: 'retail'})
        this.departmentGroup = [{
          id: '',
          name: 'Tất cả'
        }]
        if (_.get(response, 'success', false)) {
          let departmentGroup = _.get(response, 'data', []);
          // if (!this.isManager()) {
          //   const dataUser = TokenService.getUser() || {};
          //   departmentGroup = departmentGroup.filter(d => d.id == dataUser.departmentId);
          //   this.departmentGroup = departmentGroup;
          // } else {
          //   this.departmentGroup.push(...departmentGroup);
          // }
          this.departmentGroup.push(...departmentGroup);
        }
      },
      
      changeDateRange (dateRange) {
        this.filterForm.dateRange = dateRange
        this.selectRange = dateRange
      }
    }
  }
</script>